import {
  SlMenuLabel
} from "./chunk.6JESXXUD.js";

// src/components/menu-label/menu-label.ts
var menu_label_default = SlMenuLabel;
SlMenuLabel.define("sl-menu-label");

export {
  menu_label_default
};
